import { createBreakpoints } from '@chakra-ui/theme-tools'

export const breakpoints = createBreakpoints({
  '2xl': '240rem',
  '3xl': '320rem',
  '4k': '240rem',
  '4xl': '480rem',
  '8k': '480rem',
  desktop: '90rem',
  fullhd: '120rem',
  lg: '90rem',
  md: '64rem',
  mobile: '40rem',
  sm: '40rem',
  tablet: '64rem',
  xl: '120rem',
})

export type NaturalBreakpoint =
  | 'mobile'
  | 'tablet'
  | 'desktop'
  | 'fullhd'
  | '4k'
  | '8k'

export const naturalResolutionMap: Record<
  NaturalBreakpoint,
  keyof typeof breakpoints
> = {
  '4k': '4k',
  '8k': '8k',
  desktop: 'lg',
  fullhd: 'xl',
  mobile: 'sm',
  tablet: 'md',
}
